<div class="mobile-cart-footer" [class.expanded]="expanded" *ngIf="hasCart$ | async">
  <button
    type="button"
    class="drag-handle"
    (click)="toggle()"
    [attr.aria-expanded]="expanded"
    [attr.aria-label]="'cart.toggle_order_summary' | transloco"
  >
    <span class="drag-handle-chevron"></span>
  </button>

  <div class="expanded-content-wrapper" [attr.aria-hidden]="!expanded" [attr.inert]="!expanded ? '' : null">
    <div class="expanded-content">
      <h3 class="expanded-title">{{ 'cart.your_order' | transloco }}</h3>
      <plys-subscription-cart-preview
        *ngIf="isSubscription$ | async; else cartPreview"
        [hideSummary]="true"
        [firstTermCharge]="(firstTermCharge$ | async) === true"
      ></plys-subscription-cart-preview>
      <ng-template #cartPreview>
        <plys-cart-preview [hideSummary]="true"></plys-cart-preview>
      </ng-template>
    </div>
  </div>

  <div class="footer-row">
    <strong class="total" (click)="toggle()">
      <span class="total-label">{{ totalLabelKey$ | async | transloco }}</span>
      <span class="total-value">{{ total$ | async | localeCurrency: 'EUR' }}</span>
    </strong>
    <div class="actions">
      <ng-content select="[cartFooterBack]"></ng-content>
      <ng-content select="[cartFooterContinue]"></ng-content>
    </div>
  </div>
</div>
